var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary_Logo_White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173.3 173.3",
    style: {
      enableBackground: "new 0 0 173.3 173.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.6,50.3c-1.4-2-2.6-4.1-3.6-6.3c0.6,7.6,3,19.7,10.5,34.9c8.2-1.8,15.9-5.6,22.4-11v-0.1 C143.3,65.7,134.4,57.3,129.6,50.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.3,84.3L121.3,84.3c-9.2,0.1-18.4-1.7-26.8-5.3c-6.4-2.9-12.2-6.9-17.1-11.8c-4.8-4.8-8.7-10.4-11.5-16.7 L63.3,49c0.2,4,1.4,11.9,6.1,22.7c4.3,9.5,9.7,18.6,16,26.9h73.5V72.7c-3.3,2.5-6.9,4.6-10.7,6.3C139.7,82.6,130.6,84.5,121.3,84.3z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,44.9l0.9-1.8l8.3,4.8l0.2,0.6c2.6,6,6.3,11.5,11,16.1l0,0c4.6-0.5,9-1.8,13.2-3.8 c10.3-5,18.3-13.9,23.8-26.4l0.5-1.1h8.7c1.1,5.4,3.4,10.5,6.5,15c6.1,8.8,14.9,14.1,26.1,15.8l0.1-49.5H14.6l-0.1,66.9 c1.1-0.3,2.3-0.7,3.4-1.1C31.4,75.5,49.7,65.5,59.8,44.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,89.1v9.5h51.7c-10.9-4.1-22.2-6.8-33.8-8.1C26,89.7,19.9,89.3,14.4,89.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,107.4h18.2c18.8,0,28.8,9.3,28.8,25.4c0,16.6-9.2,26.1-28.8,26.1H14.4V107.4z M34,147.6 c8.8,0,13.2-5.7,13.2-14.7c0-8.7-4.7-14.3-13.2-14.3h-5.4v29L34,147.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,107.4h38.8v12.2H81.3v7.9h21.8v10.6H81.3v8.6h24.9v12.2H67.1V107.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.8,107.4h13.5l19.3,29.3v-29.3h13.4v51.5h-13.4l-19.3-29.1v29.1h-13.4V107.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c517bdc574ad1b95a5b0adae0875d5d.svg";
export { ForwardRef as ReactComponent };